var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 48h-8v40h8V48zM42 30h-8v8h8v-8zM62 73v-5c0-6.1 4.9-11 11-11s11 4.9 11 11v20h8V68c0-10.5-8.5-19-19-19-4.1 0-7.9 1.3-11 3.5V48h-8v40h8V73z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 0H0v126h126V0zm-8 118H8V8h110v110z",
    fill: "#000"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI2IiBoZWlnaHQ9IjEyNiIgdmlld0JveD0iMCAwIDEyNiAxMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00MiA0OEgzNFY4OEg0MlY0OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik00MiAzMEgzNFYzOEg0MlYzMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02MiA3M1Y2OEM2MiA2MS45IDY2LjkgNTcgNzMgNTdDNzkuMSA1NyA4NCA2MS45IDg0IDY4Vjg4SDkyVjY4QzkyIDU3LjUgODMuNSA0OSA3MyA0OUM2OC45IDQ5IDY1LjEgNTAuMyA2MiA1Mi41VjQ4SDU0VjY4VjczVjg4SDYyVjczWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyNiAwSDBWMTI2SDEyNlYwWk0xMTggMTE4SDhWOEgxMThWMTE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgLinkedin as ReactComponent };